import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/loginByPhone', component: () => import('@/views/login/loginByPhone'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  // ========== 新增：注册页（公开访问）==========
  {
    path: '/register',
    component: () => import('@/views/ums/admin/register'),
    hidden: true
  },
  //新增手机验证码找回密码功能
  {
    path: '/forgetPassword',
    name: 'forgetPassword',
    component: () => import('@/views/login/forgetPassword.vue'),
    hidden: true
  },
  // ==========================================
  {
    path: '',
    component: Layout,
    redirect: '/home',
    meta: {title: '首页', icon: 'home'},
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import('@/views/sc/myPredictSc'),
        meta: {title: '我的志愿收藏', icon: 'video'}
      }
      // 删除 zsjhsc 招生计划收藏路由
    ]
  }
]

export const asyncRouterMap = [
  {
    path: '/pms',
    component: Layout,
    redirect: '/pms/product',
    name: 'pms',
    meta: {title: '商品', icon: 'product'},
    children: [{
      path: 'product',
      name: 'product',
      component: () => import('@/views/pms/product/index'),
      meta: {title: 'VIP服务列表', icon: 'product-list'}
    },
      {
        path: 'addProduct',
        name: 'addProduct',
        component: () => import('@/views/pms/product/add'),
        meta: {title: '添加VIP服务', icon: 'product-add'}
      },
      {
        path: 'updateProduct',
        name: 'updateProduct',
        component: () => import('@/views/pms/product/update'),
        meta: {title: '修改VIP服务', icon: 'product-add'},
        hidden: true
      }
    ]
  },

  {
    path: '/tbYcfx',
    component: Layout,
    redirect: '/tbYcfx/analysis',
    name: 'tbYcfx',
    meta: {
      title: '填报预测分析（提前批次）',
      icon: 'chart'
    },
    alwaysShow: true,
    children: [
      {
        path: 'analysis',
        name: 'tbYcfxAnalysis',
        component: () => import('@/views/ycfx/tbYcfx/analysis.vue'),
        meta: { title: '录取率分析', icon: 'chart' }
      },
      {
        path: 'batchA',
        name: 'tbYcfxBatchA',
        component: () => import('@/views/ycfx/tbYcfx/batchA.vue'),
        meta: { title: '本科提前批A段', icon: 'list' }
      },
      {
        path: 'batchB',
        name: 'tbYcfxBatchB',
        component: () => import('@/views/ycfx/tbYcfx/batchB.vue'),
        meta: { title: '本科提前批B段', icon: 'list' }
      },
      {
        path: 'batchC',
        name: 'tbYcfxBatchC',
        component: () => import('@/views/ycfx/tbYcfx/batchC.vue'),
        meta: { title: '本科提前批C段', icon: 'list' }
      },
      {
        path: 'batchGZ',
        name: 'tbYcfxBatchGZ',
        component: () => import('@/views/ycfx/tbYcfx/batchGZ.vue'),
        meta: { title: '高职(专科)提前批', icon: 'list' }
      }
    ]
  },
  {
    path: '/adms',
    component: Layout,
    redirect: '/adms/history',
    name: 'adms',
    meta: {title: '录取情况分析', icon: 'product'},
    alwaysShow: true,
    children: [
      {
        path: 'analysis',
        name: 'analysis',
        component: () => import('@/views/adms/analysis/index'),
        meta: { title: '录取情况分析', icon: 'product-list' }
      },
      {
        path: 'history',
        name: 'history',
        component: () => import('@/views/adms/history/index'),
        meta: { title: '历年录取分数查询', icon: 'product-list' }
      }
    ]
  },
  // 专业目录查询
  {
    path: '/zyml',
    component: Layout,
    redirect: '/zyml/zyml',
    name: 'zyml',
    meta: {title: '专业目录查询', icon: 'list'},
    children: [
      {
        path: 'zyml',
        name: 'zymlQuery',
        component: () => import('@/views/zyml/zyml/index'),
        meta: { title: '专业目录查询', icon: 'list' }
      },
      {
        path: 'zymlXz',
        name: 'zymlXzQuery',
        component: () => import('@/views/zyml/zymlXz/index'),
        meta: { title: '新增专业目录查询', icon: 'list' }
      }
    ]
  },
  {
    path: '/ycfx',
    component: Layout,
    redirect: '/ycfx/analysis',
    name: 'ycfx',
    meta: { title: '填报预测分析（普通、专项类）', icon: 'chart' },
    alwaysShow: true,
    children: [
      {
        path: 'analysis',
        name: 'ycfxAnalysis',
        component: () => import('@/views/ycfx/analysis/index'),
        meta: { title: '录取率分析', keepAlive: true }
      }
    ]
  },

// 独立一级菜单：专业招生计划
  {
    path: '/zyzsjh',
    component: Layout,
    redirect: '/zyzsjh/index',
    name: 'zyzsjhQuery',
    meta: { title: '全国高校在贵州招生计划', icon: 'chart' }, // 自行更换图标
    children: [
      {
        path: 'index',
        name: 'zyzsjhQueryPage',
        component: () => import('@/views/enrPlan/components/EnrPlanTab.vue'),
        meta: { title: '全国高校在贵州招生计划', keepAlive: true }
      }
    ]
  },

// 独立一级菜单：新增专业招生计划
  {
    path: '/gkksXz',
    component: Layout,
    redirect: '/gkksXz/index',
    name: 'gkksXzQuery',
    meta: { title: '全国新增院校和专业招生计划', icon: 'chart' }, // 自行更换图标
    children: [
      {
        path: 'index',
        name: 'gkksXzQueryPage',
        component: () => import('@/views/zyml/gkksXz/index'),
        meta: { title: '全国新增院校和专业招生计划', keepAlive: true }
      }
    ]
  },
  // ====================== 【修复】模型概率配置 ======================
  {
    path: '/mxgl',
    component: Layout,
    redirect: '/mxgl/lqtbjy',
    name: 'mxglConfig',
    meta: { title: '模型概率配置', icon: 'tree' },
    alwaysShow: true,
    children: [
      {
        path: 'lqtbjy',
        name: 'SysLqtbjy',
        component: () => import('@/views/mxgl/SysLqtbjy.vue'),
        meta: { title: '录取建议维护' }
      },
      {
        path: 'lqgl',
        name: 'SysLqgl',
        component: () => import('@/views/mxgl/SysLqgl.vue'),
        meta: { title: '录取规则维护' }
      }
    ]
  },
  // =================================================================

  {
    path: '/oms',
    component: Layout,
    redirect: '/oms/order',
    name: 'oms',
    meta: {title: '订单', icon: 'order'},
    children: [
      {
        path: 'order',
        name: 'order',
        component: () => import('@/views/oms/order/index'),
        meta: {title: '订单列表', icon: 'product-list'}
      },
      {
        path: 'orderAdd',
        name: 'orderAdd',
        component: () => import('@/views/oms/order/orderAdd'),
        meta: {title: '添加订单'},
        hidden:true
      },
      {
        path: 'orderDetail',
        name: 'orderDetail',
        component: () => import('@/views/oms/order/orderDetail'),
        meta: {title: '订单详情'},
        hidden:true
      },
      {
        path: 'orderPay',
        name: 'orderPay',
        component: () => import('@/views/oms/order/orderPay'),
        meta: {title: '订单支付'},
        hidden:true
      }
    ]
  },
  {
    path:'/sms',
    component: Layout,
    redirect: '/sms/coupon',
    name: 'sms',
    meta: {title: '营销', icon: 'sms'},
    children: [
      {
        path: 'flash',
        name: 'flash',
        component: () => import('@/views/sms/flash/index'),
        meta: {title: '秒杀活动列表', icon: 'sms-flash'}
      },
      {
        path: 'flashSession',
        name: 'flashSession',
        component: () => import('@/views/sms/flash/sessionList'),
        meta: {title: '秒杀时间段列表'},
        hidden:true
      },
      {
        path: 'selectSession',
        name: 'selectSession',
        component: () => import('@/views/sms/flash/selectSessionList'),
        meta: {title: '秒杀时间段选择'},
        hidden:true
      },
      {
        path: 'flashProductRelation',
        name: 'flashProductRelation',
        component: () => import('@/views/sms/flash/productRelationList'),
        meta: {title: '秒杀商品列表'},
        hidden:true
      },
      {
        path: 'coupon',
        name: 'coupon',
        component: () => import('@/views/sms/coupon/index'),
        meta: {title: '优惠券列表', icon: 'sms-coupon'}
      },
      {
        path: 'addCoupon',
        name: 'addCoupon',
        component: () => import('@/views/sms/coupon/add'),
        meta: {title: '添加优惠券'},
        hidden:true
      },
      {
        path: 'updateCoupon',
        name: 'updateCoupon',
        component: () => import('@/views/sms/coupon/update'),
        meta: {title: '修改优惠券'},
        hidden:true
      },
      {
        path: 'couponHistory',
        name: 'couponHistory',
        component: () => import('@/views/sms/coupon/history'),
        meta: {title: '优惠券领取详情'},
        hidden:true
      },
      {
        path: 'brand',
        name: 'homeBrand',
        component: () => import('@/views/sms/brand/index'),
        meta: {title: '品牌推荐', icon: 'product-brand'}
      },
      {
        path: 'new',
        name: 'homeNew',
        component: () => import('@/views/sms/new/index'),
        meta: {title: '新品推荐', icon: 'sms-new'}
      },
      {
        path: 'hot',
        name: 'homeHot',
        component: () => import('@/views/sms/hot/index'),
        meta: {title: '人气推荐', icon: 'sms-hot'}
      },
      {
        path: 'subject',
        name: 'homeSubject',
        component: () => import('@/views/sms/subject/index'),
        meta: {title: '专题推荐', icon: 'sms-subject'}
      },
      {
        path: 'advertise',
        name: 'homeAdvertise',
        component: () => import('@/views/sms/advertise/index'),
        meta: {title: '广告列表', icon: 'sms-ad'}
      },
      {
        path: 'addAdvertise',
        name: 'addHomeAdvertise',
        component: () => import('@/views/sms/advertise/add'),
        meta: {title: '添加广告'},
        hidden:true
      },
      {
        path: 'updateAdvertise',
        name: 'updateHomeAdvertise',
        component: () => import('@/views/sms/advertise/update'),
        meta: {title: '编辑广告'},
        hidden:true
      }
    ]
  },
  {
    path:'/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {title: '权限', icon: 'ums'},
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: {title: '用户列表', icon: 'ums-admin'}
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: {title: '角色列表', icon: 'ums-role'}
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: {title: '分配菜单'},
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: {title: '分配资源'},
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: {title: '菜单列表', icon: 'ums-menu'}
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: {title: '添加菜单'},
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: {title: '修改菜单'},
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: {title: '资源列表', icon: 'ums-resource'}
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: {title: '资源分类'},
        hidden: true
      }
    ]
  },

  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js